import React from "react";
import { Link, useParams } from "react-router-dom";
import { CompanyAccess, ServiceProxy } from "@me-team/host/main/graphql/types";
import { WithRoleAccess } from "@services/ui-components";

interface ServiceNameWithOptionalLinkProps {
    service: ServiceProxy;
    currentCompanyId: number;
}

const ServiceNameWithOptionalLink: React.FC<ServiceNameWithOptionalLinkProps> = ({ service, currentCompanyId }) => {
    const { branchId } = useParams();

    return (
        <WithRoleAccess
            permission={CompanyAccess.ServiceListView}
            fallback={<span className={service?.deleted ? "text-secondary" : "text-dark"}>{service?.name}</span>}
        >
            <Link
                to={`/services/service/${currentCompanyId}/service-list/${service?.id}/edit/${branchId}`}
                className={service?.deleted ? "text-secondary" : "text-primary"}
                style={{ textDecoration: "none" }}
            >
                {service?.name}
            </Link>
        </WithRoleAccess>
    );
};

export default ServiceNameWithOptionalLink;
